import apiClient from 'apiClient';
import { DueDiligenceStatus } from 'screens/Panel/types/dueDiligence';
import { handleError } from 'screens/Panel/api/errorHandler';

export const setFirstLineStatus = async (clubId: string, status: DueDiligenceStatus) => {
  try {
    const response = await apiClient.put(`/api/v1/broker-management/clubs/${clubId}/due-diligence/first-line`, {
      status,
    });
    return response.data;
  } catch (e) {
    handleError(e);
  }
};

export const setSecondLineStatus = async (clubId: string, status: DueDiligenceStatus) => {
  try {
    const response = await apiClient.put(`/api/v1/broker-management/clubs/${clubId}/due-diligence/second-line`, {
      status,
    });
    return response.data;
  } catch (e) {
    handleError(e);
  }
};
